import React, { useEffect, useState } from 'react';
import { Card, Table, Pagination, message } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { useInjectSaga } from 'utils/injectSaga';
import { useInjectReducer } from 'utils/injectReducer';
import reducer, { initialState } from './reducer';
import saga from './saga';
import _ from 'lodash';
import { listNotification } from './action';
import clientReducer, { initialState as clientInitialState } from 'pages/Client/reducer';
import clientSaga from 'pages/Client/saga';
import { NotificationTableConfig } from './NotificationTableConfig';

function NotificationReport() {
  useInjectReducer({ key: 'notification', reducer });
  useInjectSaga({ key: 'notification', saga });
  useInjectReducer({ key: 'client', reducer: clientReducer });
  useInjectSaga({ key: 'client', saga: clientSaga });
  const [columns, setColumns] = useState([]);
  const [searchText, setSearchText] = useState(null);
  const [searchedColumn, setSearchedColumn] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const notificationState = useSelector((state) => state.notification || initialState);
  const authState = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  useEffect(() => {
    const columns = NotificationTableConfig(handleSearch, handleReset, authState.userResponsibilities);
    setColumns(columns);
    dispatch(listNotification({ page: 1, limit: 10 }));
  }, []);

  const resetPagination = () => setCurrentPage(1);

  const onPageChange = (page, pageSize) => {
    let filter = { page, limit: pageSize };
    setCurrentPage(page);
    if ((searchedColumn, searchText)) {
      filter = { ...filter, [searchedColumn]: searchText };
    }
    dispatch(listNotification(filter));
  };

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    if (selectedKeys.length <= 0) {
      message.error('Please select to search');
      return;
    }
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
    dispatch(listNotification({ page: 1, limit: 10, [dataIndex]: selectedKeys[0] }));
    resetPagination();
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText(null);
    setSearchedColumn(null);
    dispatch(listNotification({ page: 1, limit: 10 }));
    resetPagination();
  };
  return (
    <>
      <Card title="Notifications">
        <Table
          columns={columns}
          loading={notificationState.loading}
          bordered
          pagination={false}
          size={'small'}
          dataSource={notificationState.data}
          style={{ height: '70vh', overflow: 'scroll' }}
        />
        <Pagination
          style={{ marginTop: '10px' }}
          total={notificationState.totalCount}
          showTotal={(total) => `Total ${total} items`}
          defaultPageSize={10}
          current={currentPage}
          showLessItems={true}
          showSizeChanger={false}
          disabled={notificationState.loading}
          onChange={onPageChange}
        />
      </Card>
    </>
  );
}

export default NotificationReport;
